import { render, staticRenderFns } from "./vis-page-post-logout.vue?vue&type=template&id=49e23dd2"
import script from "./vis-page-post-logout.vue?vue&type=script&lang=js"
export * from "./vis-page-post-logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports